// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getUnixTime as fn } from "../getUnixTime.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getUnixTime = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getUnixTime;
